import React, { Component, useState, useEffect, useCallback } from 'react';
import parse, { domToReact } from 'html-react-parser';
import sanitizeHtml from 'sanitize-html';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import styled from '@emotion/styled';
import { getLocalStorageItem, createLocalStorageChangeEvent, setLocalStorageItem, removeLocalStorageItem, isMyrealtripStorageItem } from '@myrealtrip/browser';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

var HTMLRenderer = function (_a) {
    var _b = _a.html, html = _b === void 0 ? '' : _b, _c = _a.components, components = _c === void 0 ? {} : _c, _d = _a.componentOverrides, componentOverrides = _d === void 0 ? {} : _d, sanitizeOptions = _a.sanitizeOptions;
    var resolvedComponents = Object.keys(componentOverrides).reduce(function (acc, key) {
        var _a;
        var Comp = (_a = components[key]) !== null && _a !== void 0 ? _a : (function (props) { return React.createElement(key, props); });
        acc[key] = componentOverrides[key](Comp);
        return acc;
    }, __assign({}, components));
    var parserOptions = {
        replace: function (_a) {
            var name = _a.name, attribs = _a.attribs, nodes = _a.children;
            var children = nodes
                ? domToReact(nodes, __assign({}, parserOptions))
                : null;
            var Component = resolvedComponents[name];
            if (!Component)
                return;
            return React.createElement(Component, __assign({}, attribs), children);
        },
    };
    return parse(sanitizeHtml(html, __assign({ disallowedTagsMode: 'escape', allowedTags: sanitizeHtml.defaults.allowedTags.concat(['img', 'br', 'hr']), allowedSchemes: ['http', 'https', 'mailto', 'tel', 'mrt'] }, sanitizeOptions)), parserOptions);
};

function NormalErrorFallback(_a) {
    var _b = _a.title, title = _b === void 0 ? '일시적인 오류가 발생했습니다.' : _b, _c = _a.description, description = _c === void 0 ? '잠시 후 다시 시도해 주세요.' : _c, onClickReturn = _a.onClickReturn;
    var handleReturn = function () {
        onClickReturn === null || onClickReturn === void 0 ? void 0 : onClickReturn();
    };
    return (jsxs(Container, { children: [jsx(Title, { children: title }), jsx(Description, { children: description }), jsx(Button, { onClick: handleReturn, children: "\uCC98\uC74C\uC73C\uB85C \uB3CC\uC544\uAC00\uAE30" })] }));
}
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  max-width: 358px;\n  color: #101418;\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  max-width: 358px;\n  color: #101418;\n"])));
var Title = styled.h4(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 24px;\n  line-height: 1.3;\n  font-weight: 700;\n  margin-bottom: 23px;\n  text-align: center;\n"], ["\n  font-size: 24px;\n  line-height: 1.3;\n  font-weight: 700;\n  margin-bottom: 23px;\n  text-align: center;\n"])));
var Description = styled.p(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\nfont-size: 15px;\nline-height: 1.38\nfont-weight: 500;\nletter-spacing: -0.01em;\ntext-align: center;\nmargin-bottom: 40px;\ncolor: #495056\n"], ["\nfont-size: 15px;\nline-height: 1.38\nfont-weight: 500;\nletter-spacing: -0.01em;\ntext-align: center;\nmargin-bottom: 40px;\ncolor: #495056\n"])));
var Button = styled.button(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 56px;\n  border-radius: 12px;\n  background-color: #101418;\n  color: var(--white);\n  margin-bottom: 12px;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 56px;\n  border-radius: 12px;\n  background-color: #101418;\n  color: var(--white);\n  margin-bottom: 12px;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;

var errorBoundaryState = {
    error: null,
};
var ErrorBoundary = /** @class */ (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.resetState = function () {
            _this.setState(errorBoundaryState);
        };
        _this.resetErrorBoundary = _this.resetErrorBoundary.bind(_this);
        _this.state = errorBoundaryState;
        return _this;
    }
    ErrorBoundary.getDerivedStateFromError = function (error) {
        return { error: error };
    };
    ErrorBoundary.prototype.resetErrorBoundary = function () {
        var _a, _b;
        var error = this.state.error;
        (_b = (_a = this.props).onReset) === null || _b === void 0 ? void 0 : _b.call(_a);
        if (error !== null)
            this.resetState();
    };
    ErrorBoundary.prototype.componentDidCatch = function (error, errorInfo) {
        var _a = this.props.name, name = _a === void 0 ? 'global' : _a;
        console.error("".concat(name, " ErrorBoundary error"), error);
        console.error("".concat(name, " ErrorBoundary componentStack"), errorInfo.componentStack);
    };
    ErrorBoundary.prototype.componentWillUnmount = function () {
        this.resetState();
    };
    ErrorBoundary.prototype.render = function () {
        var _a = this.props, fallbackRender = _a.fallbackRender, children = _a.children, fallback = _a.fallback;
        var error = this.state.error;
        if (error) {
            if (fallbackRender) {
                return fallbackRender({
                    error: error,
                    resetErrorBoundary: this.resetErrorBoundary,
                });
            }
            return typeof fallback === 'undefined' ? (jsx(NormalErrorFallback, { onClickReturn: this.resetErrorBoundary })) : (fallback);
        }
        return children;
    };
    return ErrorBoundary;
}(Component));

function tryParse(value) {
    try {
        return JSON.parse(value);
    }
    catch (_a) {
        return value;
    }
}
function isTypeOflocalStorageChangeEvent(evt) {
    return Boolean(evt) && evt.type === createLocalStorageChangeEvent.eventName;
}
function useLocalStorage(key, defaultValue) {
    if (defaultValue === void 0) { defaultValue = null; }
    var _a = useState(getLocalStorageItem(key)), localState = _a[0], setLocalState = _a[1];
    var onLocalStorageChange = function (event) {
        if (isTypeOflocalStorageChangeEvent(event)) {
            if (event.detail.key === key) {
                setLocalState(event.detail.data);
            }
        }
        else {
            if (event.key === key) {
                if (event.newValue === null)
                    return setLocalState(null);
                var parsedData = tryParse(event.newValue);
                setLocalState(isMyrealtripStorageItem(parsedData) ? parsedData.data : parsedData);
            }
        }
    };
    useEffect(function () {
        var listener = function (e) {
            return onLocalStorageChange(e);
        };
        window.addEventListener(createLocalStorageChangeEvent.eventName, listener);
        window.addEventListener('storage', listener);
        if (localStorage.getItem(key) === null && defaultValue !== null) {
            setLocalStorageItem(key, defaultValue);
        }
        return function () {
            window.removeEventListener(createLocalStorageChangeEvent.eventName, listener);
            window.removeEventListener('storage', listener);
        };
    }, [key]);
    var writeState = useCallback(function (value, expiryHour) { return setLocalStorageItem(key, value, expiryHour); }, [key]);
    var deleteState = useCallback(function () { return removeLocalStorageItem(key); }, [key]);
    var state = localState !== null && localState !== void 0 ? localState : defaultValue;
    return [state, writeState, deleteState];
}

export { ErrorBoundary, HTMLRenderer, useLocalStorage };
